import type { AssertTrue, ValidateEnumMatchesType } from "@/domains/typing/types";
import type { ApiSchema } from "@/modules/api";

export const SubscriptionPlanKind = {
  FREE: "free",
  PRO: "pro",
  PROACTIVE: "proactive",
  UNKNOWN: "unknown",
} as const;
export type SubscriptionPlanKind = (typeof SubscriptionPlanKind)[keyof typeof SubscriptionPlanKind];

type ValidSubscriptionPlanKind = ApiSchema["SubscriptionPlanKind"];
type _ValidateSubscriptionPlanKind = AssertTrue<
  ValidateEnumMatchesType<ValidSubscriptionPlanKind, SubscriptionPlanKind>
>;

export const SubscriptionPlanVariant = {
  STANDARD: "standard",
  MAX: "max",
} as const;
export type SubscriptionPlanVariant =
  (typeof SubscriptionPlanVariant)[keyof typeof SubscriptionPlanVariant];

type ValidSubscriptionPlanVariant = ApiSchema["SubscriptionPlanVariant"];
type _ValidateSubscriptionPlanVariant = AssertTrue<
  ValidateEnumMatchesType<ValidSubscriptionPlanVariant, SubscriptionPlanVariant>
>;

type GeneratedBillingSubscriptionData = ApiSchema["PlatformUnifiedSubscription"];
type GeneratedPlatformEntitlementsData = ApiSchema["PlatformEntitlements"];
export type BillingSubscriptionData = GeneratedBillingSubscriptionData & {
  plan_variant?: SubscriptionPlanVariant | "" | null;
  subscription_ends_at?: string | null;
};
export type PlatformEntitlementsData = GeneratedPlatformEntitlementsData & {
  plan_variant?: SubscriptionPlanVariant | "" | null;
};
export type BillingSubscriptionProvider = Exclude<
  NonNullable<BillingSubscriptionData["provider"]>,
  ""
>;
export type BillingSubscriptionStatus = BillingSubscriptionData["status"];

export type SubscriptionTier = BillingSubscriptionData["tier"] | PlatformEntitlementsData["tier"];
